export default {
  educationTagList: '/course/supply/degree/tag/page',
  educationTagCreate: '/course/supply/degree/tag/create',
  educationTagEdit: '/course/supply/degree/tag/update',
  educationTagBatchDelete: '/course/supply/degree/tag/remove',
  educationStatusUpdate: '/course/supply/degree/tag/status/edit',

  // 学历报名
  degreeSignUpList: '/course/identify/admin/degree/enroll/page',
  degreeSignUpDetailExport: '/course/identify/admin/degree/enroll/detail/export',
  degreeSignUpListExport: '/course/identify/admin/degree/enroll/export',
  degreeProductQrCode: '/third/identify/wx/getUnlimitedQRCode/simple',
  degreeEnrollDetail: '/course/identify/admin/degree/enroll/info',
  degreeMaterialUpdate: '/course/identify/admin/degree/enroll/edit',
  degreeMaterialSubmit: '/course/identify/admin/degree/enroll/audit',
  degreeProductEnrollCheck: '/course/identify/admin/degree/enroll/check-order',
}
